import { __assign } from "tslib";
import { SchemaActionType, KeyGenerator, } from '@tencent/memoire-core';
import IndexBuilder from './index-builder';
var CollectionBuilder = /** @class */ (function () {
    function CollectionBuilder(name, context) {
        this.name = name;
        this.context = context;
    }
    CollectionBuilder.create = function (context) {
        return {
            collection: function (name) {
                return new CollectionBuilder(name, context);
            },
        };
    };
    CollectionBuilder.prototype.create = function (attributes) {
        this.context.actions.schema.push({
            type: SchemaActionType.CreateCollection,
            name: this.name,
            attributes: __assign({}, attributes),
        });
        return this;
    };
    CollectionBuilder.prototype.drop = function () {
        this.context.actions.schema.push({ type: SchemaActionType.DropCollection, name: this.name });
    };
    CollectionBuilder.prototype.alter = function (attributes) {
        this.context.actions.schema.push({ type: SchemaActionType.DropCollection, name: this.name }, { type: SchemaActionType.CreateCollection, name: this.name, attributes: __assign({}, attributes) });
        return this;
    };
    CollectionBuilder.prototype.rename = function (name) {
        this.context.actions.schema.push({ type: SchemaActionType.DropCollection, name: this.name }, 
        // TODO: use current attrs to rebuild Collection
        {
            type: SchemaActionType.CreateCollection,
            name: name,
            attributes: { key: { generator: KeyGenerator.AutoIncrement }, properties: [] },
        });
    };
    CollectionBuilder.prototype.ensure = function (cb) {
        var context = this.context;
        var builder = __assign({}, IndexBuilder.create(context));
        this.context.scope.collection = this.name;
        cb(builder);
        this.context.scope.collection = null;
    };
    return CollectionBuilder;
}());
export default CollectionBuilder;
//# sourceMappingURL=collection-builder.js.map